export const get_apollo_count = "Get_Apollo_Count"
export const get_apollo_data = "Get_Apollo_Data"

export const get_AI_Contact_Data = "get_AI_Contact_Data"
export const get_AI_Contact_Data_Update = "get_AI_Contact_Data_Update"
export const get_Viedwed_Contact_Data = "get_Viedwed_Contact_Data"